module.exports = __webpack_public_path__ + "img/service1.4412320d.png";